import { render, staticRenderFns } from "./combine-patients.dialog.vue?vue&type=template&id=fcc8f0a8&scoped=true&"
import script from "./combine-patients.dialog.vue?vue&type=script&lang=js&"
export * from "./combine-patients.dialog.vue?vue&type=script&lang=js&"
import style0 from "./combine-patients.dialog.vue?vue&type=style&index=0&id=fcc8f0a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc8f0a8",
  null
  
)

export default component.exports